import ReactGA from 'react-ga4';

export const initialize = ({measurementId}) => {
  return ReactGA.initialize(measurementId);
};

export const customEvent = ({category, action, label=''}) => {
  return ReactGA.event({category, action, label});
};
